import React from 'react';
import ReactDOM from 'react-dom';
import {RecoilRoot} from 'recoil';
import RecoilNexus from 'recoil-nexus';
import AppFeatureFlag from './AppFeatureFlag';

// compile SCSS to CSS and import here
import './styles/compiled.css';

ReactDOM.render(
    <React.StrictMode>
        <RecoilRoot>
            {/* Recoil Nexus used to make Recoil State visible outside functional component */}
            <RecoilNexus/>
            <AppFeatureFlag/>
        </RecoilRoot>
    </React.StrictMode>,
    document.getElementById('root'),
);

// Use if needed - normally not
/* function DebugObserver(): React.ReactNode | any {
  // To debug recoil sets and gets values add under <RecoilRoot> above:  <DebugObserver />
  const snapshot = useRecoilSnapshot();
  useEffect(() => {
    console.debug('%c The following atoms were modified:', 'color: #A900AC; font-weight: bold; font-family: Papyrus; font-size: 14px;');
    // This requires a flag in tsconfig - "downlevelIteration": true
    for (const node of snapshot.getNodes_UNSTABLE({isModified: true})) {
      console.debug(node.key, snapshot.getLoadable(node));
    }
  }, [snapshot]);

  return <></>;
} */
